import * as React from "react";
import { Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName } from "@fortawesome/fontawesome-svg-core";

/**
 * Container for <ActionButton> Elements
 * @param props
 */
export const ActionButtons: React.FC<React.HTMLProps<JSX.Element>> = (props) => {
  return <div className="top action-buttons">{props.children}</div>;
};

interface ActionButtonProps {
  /**
   * Image to be Displayed, this represents currently a css class
   */
  icon: string | ["fal" | "fas", string];
  /**
   * Button Label
   */
  label: string | JSX.Element;

  /**
   * Action the Button should perform
   */
  clickAction: () => void;
  badgeIcon?: string;
  iconType?: "fal" | "fas";
}

/**
 * Generalized Action ActionButton
 *
 * Future: Add support for counter badge item
 * @param props
 */
export const ActionButton: React.FC<ActionButtonProps> = (props) => {
  return (
    <Button type="default" className="btn btn-clear action-btn" onClick={props.clickAction}>
      <span className="text-center">
        {props.badgeIcon ? (
          <span className="action-btn-wrap">
            <FontAwesomeIcon icon={props.icon as IconName} size="2x" />
            <FontAwesomeIcon className="action-btn-badge-icon" icon={props.badgeIcon as IconName} />
          </span>
        ) : (
          <FontAwesomeIcon icon={["far", props.icon as IconName]} size="2x" />
        )}
      </span>
      <p className="text-center">{props.label}</p>
    </Button>
  );
};
